<app-loader *ngIf="loaderIcon | async"></app-loader>
<div class="modal-header">
    <h5 class="modal-title">Unit Relink</h5>
    <button type="button" class="close text-white" (click)="cancel()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="row align-items-end g-2">
        <div class="col-md-3 d-flex align-items-center">
            <label class="field-label me-1 mb-0 text-nowrap">
                Facility
            </label>
            <select class="form-select" [(ngModel)]="selectedFacilityId"
                (ngModelChange)="searchModel.facilityId = $event" name="facilityId">
                <option [ngValue]="null" disabled>
                    Select Facility
                </option>
                <option *ngFor="let store of allStores" [ngValue]="store.Id">
                    {{ store.Name }}
                </option>
            </select>
        </div>
        <!-- Confirmation Number -->
        <div class="col-md-3 d-flex align-items-center">
            <label class="field-label me-1 mb-0 text-nowrap">
                Confirmation #
            </label>
            <input type="text" class="form-control" [(ngModel)]="searchModel.confirmationNumber"
                name="confirmationNumber">
        </div>
        <!-- Unit Number -->
        <div class="col-md-1 d-flex align-items-center">
            <label class="field-label me-1 mb-0 text-nowrap">
                Unit #
            </label>
            <input type="text" class="form-control" [(ngModel)]="searchModel.unitNumber" name="unitNumber">
        </div>
        <!-- Tenant Name -->
        <div class="col-md-2 px-1 d-flex align-items-center">
            <label class="field-label me-1 mb-0  text-nowrap">
                Tenant Name
            </label>
            <input type="text" class="form-control" [(ngModel)]="searchModel.tenantName" name="tenantName">
        </div>
        <!-- Phone -->
        <div class="col-md-2  px-1 d-flex align-items-center">
            <label class="field-label me-1 mb-0 text-nowrap">
                Phone
            </label>
            <input type="text" class="form-control" [(ngModel)]="searchModel.phone" name="phone">
        </div>
        <!-- Search Button -->
        <div class="col-md-1 d-flex align-items-center">
            <button class="btn btn-primary w-100" (click)="searchTenantRecords()" [disabled]="!canSearch()">
                Search
            </button>
        </div>
    </div>

    <!-- Result Grid Header -->
    <div class="row mx-0 mt-3">
        <div class="scroll_outer">
            <div class="large_scroll_inner">            
                <ejs-grid #grid class="table-striped table-ipad" height="280" [dataSource]='resultList'[gridLines]='lines'
                          [allowFiltering]="true" [allowSorting]="false" [filterSettings]="filterSettings">
                    <e-columns>
                        <e-column field="select" headerText="Select" width="60" [allowFiltering]="false"
                            [allowSorting]="false" textAlign="Center">
                            <ng-template #template let-data>
                                <div class="d-flex justify-content-center">
                                    <input type="radio" name="selectedRecord" (change)="onSelectRecord(data)">
                                </div>
                            </ng-template>
                        </e-column>
                        <e-column field="type" headerText="Type" textAlign='Center' width="120"></e-column>
                        <e-column field="confirmationNumber" headerText="Confirmation #" textAlign='Center' width="160"></e-column>
                        <e-column field="unitNumber" headerText="Unit #" textAlign='Center' width="100"></e-column>
                        <e-column field="tenantName" headerText="Tenant Name" textAlign='Center' width="200"></e-column>
                        <e-column field="phoneNumber" headerText="Phone" textAlign='Center' width="250">
                            <ng-template #template let-data>
                                <span style="white-space: pre-line;">{{ formatPhoneNumber(data.PhoneNumber) }}</span>
                            </ng-template>
                        </e-column>
                        <e-column field="status" headerText="Status" textAlign='Center' width="170"></e-column>
                    </e-columns>
                </ejs-grid>             
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-primary me-3" (click)="cancel()">
        Cancel
    </button>
    <button type="button" class="btn btn-primary" [disabled]="!selectedRecord || loading" (click)="openRelinkConfirmation(relinkConfirmTemplate)">
        Relink
    </button>
</div>
<!-- Confirmation Popup -->
<ng-template #relinkConfirmTemplate>

    <div class="modal-header">
        <h5 class="modal-title">Confirm</h5>
        <button type="button" class="close" (click)="modalRef.hide()"> &times;</button>
    </div>

    <div class="modal-body ptb24">
        <p class="mb-0"> Are you sure to relink the record?</p>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary me-3" (click)="modalRef.hide()">
            No
        </button>

        <button type="button" class="btn btn-primary" (click)="proceedRelink()">
            Yes
        </button>
    </div>
</ng-template>
